export default values => ({
  discountMsi: values.discountMsi || '',
  discountMsiId: values.discountMsiId || '',
  minMsiTerm: values.minMsiTerm || '',
  maxMsiTerm: values.maxMsiTerm || '',
  minMsiInitialPayment: values.minMsiInitialPayment
    ? Number(values.minMsiInitialPayment)
    : null
});
